import { takeLatest, put, call } from 'redux-saga/effects';
import { filterMotoristaCadastro } from '../service';
import { storage } from '@commons/storage';
import {
  NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO,
  NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO_PENDING,
  NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO_SUCCESS,
  NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO_FAILURE,
} from '../actionTypes';
import { CONFIG_SESSION } from '@handler/common/startSession';
import { CONST_FILTER_MOTORISTA_CADASTRO } from '@commons/consts';

function* sagaNewFilterNextPageMotoristaCadastro(action) {
  yield put({ type: NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO_PENDING });
  try {
    const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada
      .id;
    let filterSaved =
      sessionStorage.getItem(CONST_FILTER_MOTORISTA_CADASTRO) !== null
        ? JSON.parse(
            sessionStorage.getItem(CONST_FILTER_MOTORISTA_CADASTRO),
          )
        : null;

    let newFilter = {
      ...filterSaved,
      rows: action.rows,
      page: action.page,
    };

    const list = yield call(
      filterMotoristaCadastro,
      idFazenda,
      `&page=${newFilter.page}&size=${newFilter.rows}${newFilter.where}`,
    );
    sessionStorage.setItem(
      CONST_FILTER_MOTORISTA_CADASTRO,
      JSON.stringify(newFilter),
    );

    yield put({
      type: NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO_SUCCESS,
      list: list,
      filter: newFilter,
    });
  } catch (error) {
    yield put({ type: NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO_FAILURE });
  }
}

export default function* watchNewFilterNextPageMotoristaCadastro() {
  yield takeLatest(
    NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO,
    sagaNewFilterNextPageMotoristaCadastro,
  );
}